

import React from 'react'
import { Route , Routes ,Switch } from "react-router-dom";
 import Register from './Register';
import Login from './Login';
import Newsg from './News';
import Navbarg from './Navbar';
import Home from './Home';


export default function Allroutes() {
  return (
    <>
      <Routes>
           <Route path='/' element={<Home/>}> </Route> 
           <Route path='/Login' element={<Login/>}> </Route> 
           <Route path='/Register' element={<Register/>}></Route>
        </Routes>
          
    </>
  )
}
